export default __webpack_public_path__ + "static/media/extruder-left.2b4f4812.svg";